import _asyncToGenerator from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/www/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { USER_QUERY, RESOURCE_AUTHORIZATION_QUERY } from "@app/apollo/queries";
var userRoles = {
  user: 'user',
  organiser: 'organiser',
  admin: 'admin'
};
function isAuthenticated(user) {
  return typeof user === 'object' && user !== null;
}
function hasRole(user, roleName) {
  return isAuthenticated(user) && user.role.name === roleName;
}
export function getAuthenticatedUser(_x) {
  return _getAuthenticatedUser.apply(this, arguments);
}
function _getAuthenticatedUser() {
  _getAuthenticatedUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(apolloClient) {
    var _yield$apolloClient$q, _yield$apolloClient$q2, _yield$apolloClient$q3, user;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return apolloClient.query({
              query: USER_QUERY
            });
          case 3:
            _yield$apolloClient$q = _context5.sent;
            _yield$apolloClient$q2 = _yield$apolloClient$q.data;
            _yield$apolloClient$q2 = _yield$apolloClient$q2 === void 0 ? {} : _yield$apolloClient$q2;
            _yield$apolloClient$q3 = _yield$apolloClient$q2.me, user = _yield$apolloClient$q3 === void 0 ? null : _yield$apolloClient$q3;
            return _context5.abrupt("return", user);
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            console.error(_context5.t0);
            return _context5.abrupt("return", null);
          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));
  return _getAuthenticatedUser.apply(this, arguments);
}
function canAccess(_x2, _x3, _x4, _x5) {
  return _canAccess.apply(this, arguments);
}
function _canAccess() {
  _canAccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(apolloClient, ability, resource, ResourceId) {
    var _yield$apolloClient$q4, data;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return apolloClient.query({
              query: RESOURCE_AUTHORIZATION_QUERY,
              variables: {
                input: {
                  resource: resource,
                  id: ResourceId,
                  ability: ability
                }
              }
            });
          case 3:
            _yield$apolloClient$q4 = _context6.sent;
            data = _yield$apolloClient$q4.data;
            return _context6.abrupt("return", data.can);
          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", false);
          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));
  return _canAccess.apply(this, arguments);
}
export var isAdmin = function isAdmin(user) {
  return hasRole(user, userRoles.admin);
};
export var isOrganiser = function isOrganiser(user) {
  return hasRole(user, userRoles.organiser) || isAdmin(user);
};
export var isUser = function isUser(user) {
  return isAuthenticated(user);
};
export var canManageOrganisation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(apolloClient, user, organisationId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isAdmin(user)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", true);
          case 2:
            if (!isOrganiser(user)) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", canAccess(apolloClient, 'EDIT', 'organisation', organisationId));
          case 4:
            return _context.abrupt("return", false);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function canManageOrganisation(_x6, _x7, _x8) {
    return _ref.apply(this, arguments);
  };
}();
export var canManageOpportunity = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(apolloClient, user, opportunityId) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isAdmin(user)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", true);
          case 2:
            if (!isOrganiser(user)) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", canAccess(apolloClient, 'EDIT', 'opportunity', opportunityId));
          case 4:
            return _context2.abrupt("return", false);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function canManageOpportunity(_x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();
export var canReviewOpportunity = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(apolloClient, user, opportunityId) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!isAdmin(user)) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", true);
          case 2:
            return _context3.abrupt("return", canAccess(apolloClient, 'REVIEW', 'opportunity', opportunityId));
          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function canReviewOpportunity(_x12, _x13, _x14) {
    return _ref3.apply(this, arguments);
  };
}();
export var canManageApplication = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(apolloClient, user, applicationId) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!isAdmin(user)) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return", true);
          case 2:
            return _context4.abrupt("return", canAccess(apolloClient, 'EDIT', 'application', applicationId));
          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function canManageApplication(_x15, _x16, _x17) {
    return _ref4.apply(this, arguments);
  };
}();